import ReactDOM from "react-dom";

import { IToolboxFacet } from "types";

import { ToolboxQuickSearchContainer } from "./containers";
import { BrowserRouter } from "react-router-dom";

(() => {
  const toolboxQuickSearchContainers = document.querySelectorAll<HTMLElement>(
    "[data-toolbox-quick-search]"
  );

  if (!toolboxQuickSearchContainers) return;

  toolboxQuickSearchContainers.forEach((toolboxQuickSearchContainer) => {
    const data = toolboxQuickSearchContainer.dataset.toolboxQuickSearch;
    // toolboxQuickSearchContainer.dataset.toolboxQuickSearch = ""; //cleanup

    if (!data) return;

    const toolboxQuickSearchData = JSON.parse(data) as IToolboxFacet[];

    ReactDOM.render(
      <BrowserRouter>
        <ToolboxQuickSearchContainer facets={toolboxQuickSearchData} />
      </BrowserRouter>,
      toolboxQuickSearchContainer
    );
  });
})();
